import { addSizeQuery } from "../../../utils/image";
export const getScaledLogoOfPaymentOption = (option) => {
    const logo = option.logo;
    const scaledLogo = addSizeQuery(logo, 100, 60);
    return scaledLogo;
};
